
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_1bryq_141",
  "no-content-styling": "awsui_no-content-styling_93a1u_1bryq_153",
  "disabled": "awsui_disabled_93a1u_1bryq_158",
  "show-divider": "awsui_show-divider_93a1u_1bryq_165",
  "highlighted": "awsui_highlighted_93a1u_1bryq_168",
  "is-focused": "awsui_is-focused_93a1u_1bryq_183",
  "visual-refresh": "awsui_visual-refresh_93a1u_1bryq_186",
  "menu-item": "awsui_menu-item_93a1u_1bryq_190",
  "link-style": "awsui_link-style_93a1u_1bryq_205",
  "current-breadcrumb": "awsui_current-breadcrumb_93a1u_1bryq_242",
  "link-style-highlighted": "awsui_link-style-highlighted_93a1u_1bryq_250",
  "has-category-header": "awsui_has-category-header_93a1u_1bryq_259",
  "item-tooltip-wrapper": "awsui_item-tooltip-wrapper_93a1u_1bryq_259",
  "has-checkmark": "awsui_has-checkmark_93a1u_1bryq_259",
  "icon": "awsui_icon_93a1u_1bryq_269",
  "checkmark": "awsui_checkmark_93a1u_1bryq_273",
  "external-icon": "awsui_external-icon_93a1u_1bryq_280",
  "content-wrapper": "awsui_content-wrapper_93a1u_1bryq_284",
  "main-row": "awsui_main-row_93a1u_1bryq_290",
  "label-tag": "awsui_label-tag_93a1u_1bryq_297",
  "secondary-text": "awsui_secondary-text_93a1u_1bryq_304"
};
  